module.exports = __webpack_public_path__ + "static/media/c02-01-6.656c428f.png";